import { Form, BaseModel, Resource, Entry, EntryTypes, TwoColumnLayout, TableMode } from '@ngx-resource-toolkit/core';
import { environment } from '../../../environments/environment';
import { LeaResource } from '../../shared/resource/lea.resource';
import { anneeScolaireFetchOptions, cycleFetchOptions } from '../../shared/resource/select-options';

/**
 * 
  jour: string; // "1" pour lundi, etc.
  horaire: string; // Horaire au format hh:mm
  horaireDebut: number; // en minutes, ex: "840"
  horaireFin: number; // en minutes, ex: 870
  duree: number; // durée en minutes
 */
@Resource({
    modes: {
        'default': {
            url: environment.proxyUrl + '/cours',
            methods: LeaResource.methods,
        }
    },
    /*store: {
        namespace: 'cours',
        reducer: CoursReducer,
        epics: CoursEpics,
    }*/
})
@Form({
    'edit': {
        layout: TwoColumnLayout,
    },
})
export class PauseModel extends BaseModel {

    constructor(data?) {
        super();
        this.setPause(data);
    }
    setPause(data) {
        console.log({where: 'setPause', pause: data})
        if (!data) {
            data = {};
        }
        Object.assign(this, data);
        this.anneeScolaire = +data.anneeScolaire;
        this.jour = data.jour;
        this.horaireDebut = +data.horaireDebut;
        this.horaireFin = +data.horaireFin;
        this.duree = +data.duree;
        this.horaire = data.horaire;
        this.professeurId = data.professeurId;
    }

    @Entry({
        base: {
            hidden: true,
        },
    })
    _explicitType: string = 'Pause';

    @Entry({
        base: {
            type: EntryTypes.STATIC,
            label: 'N°',
            hidden: true,
        },
        'edit': {
        }
    })
    id: string;

    @Entry({
        base: {
            type: EntryTypes.STATIC,
            label: 'N° professeur',
            hidden: true,
        },
        'edit': {
        }
    })
    professeurId: number


    @Entry({
        base: {
            type: EntryTypes.SELECT,
            label: 'Année scolaire',
            css: {
                group: 'col-xs-6'
            },
            fetchOptions: anneeScolaireFetchOptions,
        },
        'edit': {},
    })
    anneeScolaire: number;

    
    @Entry({
        base: {
        },
    })
    jour: string;

    @Entry({
        base: {
        },
    })
    horaire: string; // ?

    @Entry({
        base: {
            type: EntryTypes.NUMBER,
        },
        'edit': {},
    })
    horaireDebut: number;

    @Entry({
        base: {
            type: EntryTypes.NUMBER,
        },
        'edit': {},
    })
    horaireFin: number;

    @Entry({
        base: {
            type: EntryTypes.NUMBER,
        },
        'edit': {},
    })
    duree: number;

}




// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/cours/models/pause.model.ts